module.exports = __webpack_public_path__ + "img/phone.b5898ff4.webp";